import WithRoleAuthorization, { Role, listOfRoles } from 'components/WithRoleAuthorization/WithRoleAuthorization'
import React from 'react'
import { ForwardButton } from '../../styles'
import { notificationStatus } from 'constants/notificationStatus'
import { UserDataType } from 'types/autentication'


export interface IFinishTreatment {
  currentUser: UserDataType
  handleFinishNotification({ type }: {
    type: 'forward' | 'finish';
  }): void
  notificationStatusState: string
  loggedInUserIsResponsible: boolean
  currentStepSelected: number
  isDirtyStyle: "" | "border-mediumGray text-mediumGray"
  isDirty: boolean
  isGraveObitoOrImage: boolean
}
export const allowedStatusToShowFinishButton = [notificationStatus[3].label, notificationStatus[2].label]

export const statusPendingAllowedRolesToFinish = [
  listOfRoles.admin,
  listOfRoles.corporate_quality_board,
  listOfRoles.location_qa
]
export const allowedRolesToShowFinishButton = (
  { isGraveObitoOrImage, loggedInUserIsResponsible, notificationStatusState }:
    { notificationStatusState: string, isGraveObitoOrImage: boolean, loggedInUserIsResponsible: boolean }) => {
  if (notificationStatusState === notificationStatus[3].label) {
    return statusPendingAllowedRolesToFinish
  } else {
    return [
      listOfRoles.admin,
      listOfRoles.corporate_quality_board,
      ...(!isGraveObitoOrImage ? [listOfRoles.location_manager] : []),
      ...(loggedInUserIsResponsible
        ? [listOfRoles.location_qa]
        : [])
    ]
  }
}
export default function FinishTreatment({ isGraveObitoOrImage, isDirty, isDirtyStyle, currentStepSelected, currentUser, handleFinishNotification,
  notificationStatusState, loggedInUserIsResponsible }: IFinishTreatment) {
  const shouldRender = currentStepSelected === 6 &&
    allowedStatusToShowFinishButton.includes(notificationStatusState)

  if (!shouldRender) {
    return null
  }
  return (
    <WithRoleAuthorization
      allowedRoles={allowedRolesToShowFinishButton({ isGraveObitoOrImage, loggedInUserIsResponsible, notificationStatusState })}
      userRole={currentUser?.profile}
      children={
        <ForwardButton
          data-testid="test-finish-button"
          className={`${isDirtyStyle} ${isDirty && 'bg-disabled'
            }`}
          disabled={!!isDirty}
          type="button"
          onClick={() => handleFinishNotification({ type: 'finish' })}
        >
          Finalizar notificação
        </ForwardButton>
      }
    />
  )
}
